import { render } from "./Messages.vue?vue&type=template&id=bfe4ced6&scoped=true&ts=true"
import script from "./Messages.vue?vue&type=script&lang=ts"
export * from "./Messages.vue?vue&type=script&lang=ts"

import "./Messages.vue?vue&type=style&index=0&id=bfe4ced6&scoped=true&lang=scss"

import exportComponent from "/builds/Moodbuster2.0/server/web-server/repos/patient_portal_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfe4ced6"]])

export default __exports__